import { useEffect, useState } from "react"

import { getStoredUtmParams, persistUtmParamsFromUrl, type UtmParams } from "../utils/utm"

const useUtm = (): UtmParams => {
  const [utmParams, setUtmParams] = useState<UtmParams>(() => getStoredUtmParams())

  useEffect(() => {
    setUtmParams(persistUtmParamsFromUrl())
  }, [])

  return utmParams
}

export default useUtm
